module.exports = __webpack_public_path__ + "static/media/toggle-down.19e32020.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/toggle-down.svg
// module id = 714
// module chunks = 0